
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as adb2cEP6VZHKkbXAM_QpSph5i5N8wsHgediRdRaoTSeLNxnkMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/adb2c.vue?macro=true";
import { default as _91_46_46_46slug_93i4WYuEqdHX_CikX_hmfgGjUzXDW5ST9O4PkVhYBtJa0Meta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/[...slug].vue?macro=true";
import { default as static_45errornsLQH4gkBXs_MHXkPoqKZskRvhKChCmRM5eaBZ90uQIMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/static-error.vue?macro=true";
import { default as mybrita_45redirectgzd048_450DgxKODhvsRLlw2KP9ZnK15u_45m63IX4PfqXYMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/r/mybrita-redirect.vue?macro=true";
import { default as static_45maintenanceOI_45jMwgmEstcEed7_dyYDUdHM9Ef1zf770DhkVQVYAEMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/static-maintenance.vue?macro=true";
import { default as _91_46_46_46marketSetupLink_93vBxQXh_D9xgUxuMKN_V17jRfFo5NrdVJvM9QHE1_4581IMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/r/[...marketSetupLink].vue?macro=true";
import { default as _91_46_46_46productId_93pQnPF1DwknE9lQPwTZlhLTTZeOCh8vr1Rz0iWbnrlToMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/r/product/[...productId].vue?macro=true";
import { default as static_45yource_45maintenanceQke4sY5EHgkSxEonxjetIw8jbEs7D9Q2eTIpzvhconUMeta } from "/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/static-yource-maintenance.vue?macro=true";
export default [
  {
    name: "adb2c",
    path: "/adb2c",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/adb2c.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/[...slug].vue")
  },
  {
    name: "static-error",
    path: "/static-error",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/static-error.vue")
  },
  {
    name: "r-mybrita-redirect",
    path: "/r/mybrita-redirect",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/r/mybrita-redirect.vue")
  },
  {
    name: "static-maintenance",
    path: "/static-maintenance",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/static-maintenance.vue")
  },
  {
    name: "r-marketSetupLink",
    path: "/r/:marketSetupLink(.*)*",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/r/[...marketSetupLink].vue")
  },
  {
    name: "r-product-productId",
    path: "/r/product/:productId(.*)*",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/r/product/[...productId].vue")
  },
  {
    name: "static-yource-maintenance",
    path: "/static-yource-maintenance",
    component: () => import("/opt/bamboo/xml-data/build-dir/BRITAD2C-BMPP-JOB1/pages/static-yource-maintenance.vue")
  }
]